// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 5177 ? "home" : chunkId) + "." + {"4014":"02bb959d","5177":"cee541c1"}[chunkId] + ".css";
};